import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFormatPaint = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11 15V13C11 12.448 11.448 12 12 12H20C20.552 12 21 11.552 21 11V7C21 6.448 20.552 6 20 6H18M16.775 9H4.225C3.548 9 3 8.452 3 7.775V4.225C3 3.548 3.548 3 4.225 3H16.776C17.452 3 18 3.548 18 4.225V7.776C18 8.452 17.452 9 16.775 9ZM12 22H10C9.448 22 9 21.552 9 21V16C9 15.448 9.448 15 10 15H12C12.552 15 13 15.448 13 16V21C13 21.552 12.552 22 12 22Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgFormatPaint);
export default ForwardRef;
